import {
  Box,
  LinearProgress,
  Typography,
  capitalize,
  Tooltip,
} from "@mui/material";
import React from "react";

const SkillWisePerformance = ({ skillData }) => {
  return (
    <Box sx={{ width: "100%" }}>
      {/* header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "1rem",
          borderBottom: "1px solid #EBEBEB",
          flexWrap: "wrap",
          gap: "12px",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Nunito",
            fontWeight: 700,
            fontSize: "18px",
            lineHeight: "24px",
            color: "#363E45",
          }}
        >
          Skill-wise Performance
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "24px",
          }}
        >
          {[
            { bg: "#FF9595", text: "Beginner", tooltip: "50% and Below" },
            { bg: "#EFB02E", text: "Intermediate", tooltip: "50% - 75%" },
            { bg: "#00C49A", text: "Expert", tooltip: "75% and Above" },
          ].map((item) => {
            return (
              <Tooltip title={item.tooltip} arrow>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                  key={item.bg}
                >
                  <Box
                    sx={{
                      width: "12px",
                      height: "12px",
                      bgcolor: item.bg,
                      borderRadius: "4px",
                    }}
                  />{" "}
                  <Typography
                    sx={{
                      fontFamily: "Roboto",
                      fontWeight: 400,
                      fontSize: "14px",
                      lineHeight: "16px",
                      color: "#686868",
                    }}
                  >
                    {item.text}
                  </Typography>{" "}
                </Box>{" "}
              </Tooltip>
            );
          })}
        </Box>
      </Box>
      {/* content */}
      {skillData?.map((item, idx) => {
        return (
          <Box
            key={item.id}
            sx={{
              display: "flex",
              alignItems: "center",
              flexWrap: { base: "wrap", sm: "nowrap" },
              gap: "16px",
              padding: "0.75rem 1rem",
              borderBottom: `${
                idx + 1 !== skillData.length ? "1px dashed #EBEBEB" : "none"
              }`,
              //   strokeDasharray: 5,
              //   stroke: "#EBEBEB",
              //   strokeLinecap: "butt",
            }}
          >
            <Box sx={{ width: "130px" }}>
              <Typography
                sx={{
                  fontFamily: "Roboto",
                  fontWeight: 600,
                  fontSize: "14px",
                  lineHeight: "17px",
                  color: "#686868",
                  marginBottom: "8px",
                }}
              >
                {capitalize(item.skill.name)}
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Roboto",
                  fontWeight: 400,
                  fontSize: "12px",
                  lineHeight: "14px",
                  color: "#686868",
                }}
              >
                {`Attempted: ${item.attemptedQuestions || 0} / ${
                  item.totalQuestions || 0
                }`}
              </Typography>
            </Box>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                // justifyContent: "space-between",
              }}
            >
              <LinearProgress
                variant="determinate"
                value={
                  ((item.marksObtained || 0) / (item.totalScore || 1)) * 100
                }
                sx={{
                  width: "100%",
                  height: "12px",
                  bgcolor:
                    (item.marksObtained || 0) === 0 &&
                    (item.totalScore || 1) === 1
                      ? "transparent"
                      : "#e0e0e0",
                  "& .MuiLinearProgress-bar": {
                    borderTopRightRadius: "4px",
                    borderBottomRightRadius: "4px",
                    bgcolor:
                      ((item.marksObtained || 0) / (item.totalScore || 1)) *
                        100 >=
                      75
                        ? "#00C49A"
                        : ((item.marksObtained || 0) / (item.totalScore || 1)) *
                            100 >=
                          50
                        ? "#F0C20B"
                        : "#FD948C",
                  },
                }}
              />

              <Typography
                sx={{
                  fontFamily: "Roboto",
                  fontWeight: 700,
                  fontSize: "14px",
                  lineHeight: "18px",
                  color: "#333333",
                  marginLeft: "10px",
                }}
              >
                {`${item.marksObtained || 0}/${item.totalScore || 0}`}
              </Typography>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default SkillWisePerformance;
